import { Layout } from "../../../components/Layout";
import { Column, Grid, Row } from "carbon-components-react";
import { useLocation } from "react-router-dom";

export default function ApplePay() {
  const { pathname } = useLocation();
  return (
    <>
      <div className="doc-content">
        <h3 className="doc-title">Apple Pay ™</h3>

        <p className="text-in mb-12 black">
          Apple Pay™ allows customers to complete payments quickly and securely
          without manually entering card details. Card information is securely
          stored by Apple. Transactions are processed by LIBERTY through the
          respective card schemes. To activate Apple Pay™, select the Apple Pay™
          option during the onboarding/application process. Once the service is
          approved and enabled on Liberty’s side, we will automatically display
          the Apple Pay™ button in your payment window for applicable
          transactions.
        </p>
        <p className="text-in mb-12 black">
          In addition to the standard payment window, LIBERTY supports native
          Apple Pay™ integration, allowing you to embed the payment experience
          directly within your own iOS mobile application or website interfaces.
          Detailed implementation guidelines for native integration will be
          provided in the upcoming technical documentation.
        </p>
        <p className="text-in mb-12 black">
          LIBERTY supports VISA and MasterCard transactions from Apple Pay. You
          can use Apple Pay™ for single authorizations or for recurring billing
          authorizations. Enabling Apple Pay™ is free and can enhance the
          payment experience for your customers, potentially increasing
          conversion rates.
        </p>

       
      </div>
    </>
  );
}
